import { ensureStringIsReason, getQueryValue } from '@/utils/query-utils';

import { SearchParams } from '@domain/app';

const useReasonQuery = () => {
    const url = window.location.href.replace('#', '/');
    const query = new URL(url).searchParams;
    const reasonQuery = getQueryValue(query.get(SearchParams.REASON));

    return ensureStringIsReason(reasonQuery);
};

export default useReasonQuery;
